import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Methods from "@/components/Methods";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import { useLanguage } from "@/i18n/LanguageContext";

const Methodik = () => {
    const { t } = useLanguage();
    const seo = t.page_meta.seo.methodik;

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <div data-testid="methodik-page" className="bg-ella-cream min-h-screen">
            <Header />
            <PageMeta title={seo.title} h1={seo.h1} description={seo.description} />
            <main className="pt-32 md:pt-40">
                <div className="ella-container">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-ella-muted hover:text-ella-ink transition-colors"
                        data-testid="methodik-back-home"
                    >
                        <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
                        {t.page_meta.back_home}
                    </Link>
                </div>

                <Methods />

                <section className="py-20 md:py-28 bg-ella-onyx text-ella-cream">
                    <div className="ella-container max-w-2xl text-center">
                        <p className="font-display italic text-3xl md:text-4xl text-ella-champagne">
                            “{t.footer.quote}”
                        </p>
                        <Link
                            to="/programme"
                            data-testid="methodik-cta-programs"
                            className="mt-10 inline-flex items-center gap-3 px-9 py-4 rounded-full bg-ella-gold text-ella-onyx hover:bg-ella-gold-dark hover:text-ella-cream transition-colors text-xs uppercase tracking-[0.24em]"
                        >
                            {t.previews.programs.cta}
                            <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
                        </Link>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default Methodik;
